import { createFileRoute, redirect } from '@tanstack/react-router';

import { PlaygroundPage } from '@/pages';
import { useConfigStore } from '@/stores';
import { isPlaygroundReachable } from '@/utils/playground.ts';

export const Route = createFileRoute('/(app)/utils/playground')({
  beforeLoad: () => {
    const { env } = useConfigStore.getState();
    if (!isPlaygroundReachable(env)) {
      throw redirect({ to: '/' });
    }
  },
  component: PlaygroundPage,
});
